function setClient({ input, state }) {
  let result = input.result
  if (result.client.user) {
    result.client.selectedLocale = result.client.user.currentClient.locale
  } else {
    result.client.selectedLocale = result.client.locales[0]
  }

  result.client.registrationStep = {
    isFirst: false,
    isLast: false,
    previousPage: null,
    nextPage: null,
    validating: false
  }

  state.set('client', result.client)
}

export default setClient



// WEBPACK FOOTER //
// ./src/modules/app/actions/setClient.js